import { OnInit, Injectable, Directive } from '@angular/core';
import { BehaviorService } from '../behavior/behavior.service';

let genId = 0;

@Directive()
@Injectable()
export abstract class UiFactory implements OnInit {
  abstract get model(): any;
  constructor(public behaviorService: BehaviorService) {}

  generatedId;
  get id() {
    return this.model.id || this.generatedId;
  }

  ngOnInit() {
    if (this.model && this.model.id) {
      this.behaviorService.registerFactoryRef(this.model.id, this);
    } else {
      this.generatedId = genId++;
      this.behaviorService.registerFactoryRef(this.generatedId, this);
    }
  }
}

type Constructor<T = {}> = new (...args: any[]) => T;

export function UiFactoryMixin<TBase extends Constructor>(Base: TBase) {
  return class extends Base {
    model: any;
    behaviorService: BehaviorService;
    generatedId;

    registerId() {
      if (this.model && this.model.id) {
        this.behaviorService.registerFactoryRef(this.model.id, this);
      } else {
        this.generatedId = genId++;
        this.behaviorService.registerFactoryRef(this.generatedId, this);
      }
    }
  };
}

export function ResponsiveStylesMixin<TBase extends Constructor>(Base: TBase) {
  return class extends Base {
    model: any;
    behaviorService: BehaviorService;
    generatedId;

    registerId() {
      if (this.model && this.model.id) {
        this.behaviorService.registerFactoryRef(this.model.id, this);
      } else {
        this.generatedId = genId++;
        this.behaviorService.registerFactoryRef(this.generatedId, this);
      }
    }
  };
}
